module.exports = "<div *mobxAutorun>\n  <h1 *ngIf=\"!game.ended\"><app-cell [value]=\"game.currentPlayer\"></app-cell>'s turn</h1>\n  <h1 *ngIf=\"game.winner\"><app-cell [value]=\"game.winner\"></app-cell> has won the game</h1>\n  <h1 *ngIf=\"game.tie\"><app-cell [value]=\"'X'\"></app-cell> and <app-cell [value]=\"'O'\"></app-cell> are at tie</h1>\n  <button (click)=\"game.resetGame()\">Reset Game</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mengxin/Develop/WebProjects/xin-angular/src/app/pages/home/mobx-tic-tac/tic-tac-toe/controls/controls.component.html
// module id = ../../../../../src/app/pages/home/mobx-tic-tac/tic-tac-toe/controls/controls.component.html
// module chunks = main